import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Swipeable from 'react-swipeable';
import { deleteReport, deleteOrt } from '../actions/actions';

class SwipeComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      swipeOffset: 0,
    };
  }

  swipingLeft = (e, absX) => {
    const maxActionOffset = this.ActionContainer.clientWidth;
    const x = absX;
    if (x >= maxActionOffset || x >= maxActionOffset / 2) {
      this.setState({
        swipeOffset: maxActionOffset * -1,
      });
    } else if (x > 0) {
      this.setState({
        swipeOffset: x * -1,
      });
    } else {
      this.setState({
        swipeOffset: 0,
      });
    }
  };

  swipingRight = (e, absX) => {
    const x = absX;
    this.setState({
      swipeOffset: x < 0 ? x : 0,
    });
  };

  triggerDelete = () => {
    if (this.props.reportId) {
      this.props.deleteReport(this.props.reportId);
    }
    if (this.props.ortId) {
      this.props.deleteOrt(this.props.ortId);
    }
  };

  render() {
    if (!this.props.deleteable) {
      return this.props.children;
    }
    return (
      <div style={{ position: 'relative' }}>
        <div
          ref={node => {
            this.ActionContainer = node;
          }}
          className="SwipeActions"
        >
          <button
            onClick={this.triggerDelete}
            className="SwipeActions-button SwipeActions-button--danger"
          >
            Löschen
          </button>
        </div>
        <Swipeable
          onSwipingLeft={this.swipingLeft}
          onSwipingRight={this.swipingRight}
          onSwiped={this.onSwiped}
        >
          <div
            style={{
              transform: `translateX(${this.state.swipeOffset}px)`,
              transition: 'transform .5s ease',
            }}
          >
            {this.props.children}
          </div>
        </Swipeable>
      </div>
    );
  }
}

SwipeComponent.propTypes = {
  children: PropTypes.node.isRequired,
  deleteReport: PropTypes.func.isRequired,
  deleteOrt: PropTypes.func.isRequired,
  reportId: PropTypes.number,
  ortId: PropTypes.number,
  deleteable: PropTypes.bool,
};

SwipeComponent.defaultProps = {
  reportId: null,
  ortId: null,
  deleteable: true,
};

const mapDispatchToProps = dispatch => ({
  deleteReport: id => {
    dispatch(deleteReport(id));
  },
  deleteOrt: id => {
    dispatch(deleteOrt(id));
  },
});

export default connect(null, mapDispatchToProps)(SwipeComponent);



// WEBPACK FOOTER //
// ./src/js/components/SwipeActions.js